import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FlashMessageService } from './flash-message.service';
import { FlashMessageModel } from '../../../models/flash-message.model';

@Component({
  selector: 'app-flash-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './flash-message.component.html',
  styleUrls: ['./flash-message.component.scss']
})
export class FlashMessageComponent implements OnInit, OnDestroy {
   flashMessages: FlashMessageModel[] = [];
  private subscription!: Subscription;

  constructor(public flashMessageService: FlashMessageService) {}

  ngOnInit(): void {
    this.subscription = this.flashMessageService.alertTriggered.subscribe(
      (message: FlashMessageModel) => this.showAlert(message)
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  private showAlert(message: FlashMessageModel) {
    this.flashMessages.push(message);

    setTimeout(() => {
      this.dismiss(message);
    }, message.Duration);
  }

  dismiss(message: FlashMessageModel) {
    this.flashMessages = this.flashMessages.filter(m => m !== message);
  }

}
